<template>
  <div class="group-detail">
    <h1 class="common__main-title">Upload csv</h1>
    <div class="common__sub-title">Upload csv file</div>
    <div class="common__main-contener">
      <div class="common__main-content">
        <h6>csv file</h6>
        <FileInput v-model="selectedCsv" />
        <ErrorCsv :errorMessages="errorMessages" />
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{name:'TutorList'}"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="confirmUploadCsv"
        >
          Confirm
        </b-button>
      </div>
    </div>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="bulkUpdateTutors" />
    <SuccessModal ref="successModal" @ok="viewModel.$router.push({ name: 'TutorList' })"/>
  </div>
</template>

<script>
import _ from 'lodash';
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorCsv from '@/components/parts/ErrorCsv.vue';

export default {
  created() {
    this.viewModel = this
  },

  components: {
    FileInput,
    ConfirmModal,
    SuccessModal,
    ErrorCsv,
  },

  data: () => ({
    selectedCsv: null,
    errorMessages: [],
    isReload: false,
    viewModel: null,
  }),

  methods: {
    confirmUploadCsv() {
      try {
        if (!this.selectedCsv) {
          this.errorMessages = ['required csv file.'];
          return;
        }
        if (this.isReload) {
          return;
        }
        this.errorMessages = [];
        // 登録数チェック
        const reader = new FileReader();
        reader.onloadstart = () => {
          // 読み込み開始
          this.isReload = true;
        }
        reader.onload = () => {
          // 読み込み完了時
          // ヘッダの一行は除いてインポート人数の確認モーダルを表示
          const recordsCount = _.chain(reader)
            .get('result')
            .split('\n')
            .drop()
            .compact()
            .value()
            .length;

          this.$refs.confirmModal.open(`Import ${recordsCount} tutors. Is it OK?`);
        };
        reader.onerror = () => {
          // 読み取り失敗の場合、画面リロード
          this.errorMessages = ['selected file has error. please select file again.'];
          this.selectedCsv = null
        }
        reader.onloadend = () => {
          // 読み込み終了（成功失敗問わず）
          this.isReload = false;
          reader.abort();
        }
        reader.readAsText(this.selectedCsv);
      } catch (error) {
        this.setErrors(error);
      }
    },
    bulkUpdateTutors() {
      // チューター一括編集処理
      const conditions = {};
      const page = 1;
      this.$store.dispatch('importTutorsByCsv', this.selectedCsv)
        .then(() => {
          this.$store.dispatch('fetchTutors', { conditions, page });
          this.$refs.successModal.open();
        })
        .catch((error) => {
          this.setErrors(error);
        })
        .finally(() => {
          this.$refs.confirmModal.close();
        });
    },
    setErrors(error) {
      this.errorMessages = [error];
      if (error.response) {
        let errors = _.chain(error.response)
          .get('data.message').value();
        if (_.some(errors, (o) => _.has(o, 'message'))) {
          errors = errors
            .map(({ index, message }) => `row ${index} tutor has error: ${message}`);
        }
        this.errorMessages = Array.isArray(errors) ? errors : [errors];
      }
    },
  },
};
</script>
